// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--3nDlr","default_photo":"e2ff468f85--default_photo--Cxt5m"};